import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { UtilsService } from '../../utils/utils';
import { environment } from 'src/environments/environment';

@Injectable()
export class SolicitacaoHoraExtraService {

    routePrefix: string = 'SolicitacaoHoraExtra'
    constructor(
        private httpClient: HttpClient,
        private utilsService: UtilsService,
    ) { }

    buscarPorGestorId(id = '', data = ''): Observable<any> {
        return this.httpClient.get<Array<any>>(`${environment.urlBase}${this.routePrefix}/Buscar${this.routePrefix}PorGestorId?gestorId=${id}&data=${data}`)
            .pipe(
                retry(1),
                catchError(this.utilsService.handleError));
    }

    buscarPorUsuarioId(id = '', data = ''): Observable<any> {
      return this.httpClient.get<Array<any>>(`${environment.urlBase}${this.routePrefix}/Buscar${this.routePrefix}PorUsuarioId?usuarioId=${id}&data=${data}`)
          .pipe(
              retry(1),
              catchError(this.utilsService.handleError));
  }

    buscarConvocadosPorHoraExtraId(id = ''): Observable<any> {
        return this.httpClient.get<Array<any>>(`${environment.urlBase}${this.routePrefix}/BuscarConvocadosPorSolicitacaoHoraExtraId?solicitacaoHoraExtraID=${id}`)
            .pipe(
                retry(1),
                catchError(this.utilsService.handleError));
    }

    buscarMarmitex(): Observable<any> {
        return this.httpClient.post<Array<any>>(`${environment.urlBase}Marmitex/BuscarMarmitex`, { Tipo: '' })
            .pipe(
                retry(1),
                catchError(this.utilsService.handleError));
    }


    buscarPorColaboradorId(id = ''): Observable<any> {
        return this.httpClient.get<Array<any>>(`${environment.urlBase}${this.routePrefix}/Buscar${this.routePrefix}PorColaboradorId?colaboradorId=${id}`)
            .pipe(
                retry(1),
                catchError(this.utilsService.handleError));
    }

    buscarConvocadosPorSolicitacaoId(id = ''): Observable<any> {
        return this.httpClient.get<Array<any>>(`${environment.urlBase}${this.routePrefix}/BuscarConvocadosPor${this.routePrefix}Id?solicitacaoHoraExtraID=${id}`)
            .pipe(
                retry(1),
                catchError(this.utilsService.handleError));
    }

    buscarPorEmpresaIdData(empresaId = '', data = ''): Observable<any> {
        return this.httpClient.get<Array<any>>(`${environment.urlBase}${this.routePrefix}/Buscar${this.routePrefix}PorEmpresaIdDataSolicitacao?empresaId=${empresaId}&dataSolicitacao=${data}`)
            .pipe(
                retry(1),
                catchError(this.utilsService.handleError));
    }

    solicitar(data = {}): Observable<any> {
        return this.httpClient.post<any>(`${environment.urlBase}${this.routePrefix}/SolicitarHoraExtra`, data)
            .pipe(
                retry(1),
                catchError(this.utilsService.handleError));
    }

    convocar(data = {}): Observable<any> {
        return this.httpClient.post<any>(`${environment.urlBase}${this.routePrefix}/ConvocarFuncionarios`, data)
            .pipe(
                retry(1),
                catchError(this.utilsService.handleError));
    }

    aprovar(data = {}): Observable<any> {
        return this.httpClient.post<any>(`${environment.urlBase}${this.routePrefix}/Aprovar${this.routePrefix}`, data)
            .pipe(
                retry(1),
                catchError(this.utilsService.handleError));
    }

    reprovar(data = {}): Observable<any> {
        return this.httpClient.post<any>(`${environment.urlBase}${this.routePrefix}/Reprovar${this.routePrefix}`, data)
            .pipe(
                retry(1),
                catchError(this.utilsService.handleError));
    }

}
